import { defineComponent as _defineComponent } from 'vue'


type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: any;
}



const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'name',
    sortable: true,
  },
  {
    source: 'realms',
    label: 'Market',
    sortable: true,
    type: 'array',
    attributes: {
      color: '#00b359',
      column: true,
    },
  },
  {
    source: 'lastUpdatedAt',
    label: 'Last updated at',
  },
];

return { __sfc: true,props, fields }
}

})